import ApplicationRecord from "./ApplicationRecord";

/**
 * Home page.
 *
 *
 */
export default class HomePage extends ApplicationRecord({
  /**
   * @type {Number}
   */
  ID: -1,
  /**
     * Absolute path
     * @type {String}
     */
  URL: "",
  /**
     * Relative path
     * @type {String}
     */
  Path: "",
  /**
     * @type {String}
     */
  Title: "",
  /**
     * @type {Boolean}
     */
  ShowInMenus: false,
  /**
     * @type {Object}
     */
  _embedded: {},
}) {}
